<template>
  <div class="ebSearch" v-bind:class="{ redSearch: isRed, animateSearch:animate  }">
    <input class="search-text" v-model="text" v-on:focus="focus" v-on:blur="blur" :placeholder="placeholder" type="text" @keyup.enter="searchClick">
    <button class="search-btn" @click="searchClick">
      <i class="icon iconfont icon-sousuo"></i>
    </button>
    <div class="search-del" v-on:click="delClick" v-show="text.length>0"></div>
  </div>
</template>
<script>
export default {
  name: 'ebSearch',
  props: {
    animate: {
      default: true
    },
    placeholder: {
      default: '请输入搜索内容'
    }
  },
  data() {
    return {
      isRed: false,
      text: ''
    };
  },
  methods: {
    focus: function() {
      this.isRed = true;
    },
    blur: function() {
      this.isRed = false;
    },
    delClick: function() {
      this.text = '';
      this.$emit('search-click', this.text);
    },
    searchClick: function() {
      this.$emit('search-click', this.text);
    }
  }
};
</script>
<style scoped lang="less">
.ebSearch {
  display: flex;
  height: 100%;
  width: 298px;
  position: relative;
  justify-content: flex-end;
  .search-text {
    height: 27px;
    width: 245px;
    border: 1px solid #dfdfdf;
    padding-left: 10px;
    outline: none;
    border-right: 0;
    transition: width 0.5s;
    &::-webkit-input-placeholder {
      color: #9e9d9d;
    }
  }
  .search-btn {
    cursor: pointer;
    font-size: 16px;
    color: #fff;
    width: 37px;
    background-color: rgb(129, 130, 130);
    outline: none;
    border: 0;
    font-weight: 800;
  }
  .search-del {
    position: absolute;
    right: 45px;
    top: 7px;
    border-radius: 50%;
    height: 17px;
    width: 17px;
    cursor: pointer;
    background: url('../../assets/img/search-del.jpg') no-repeat;
  }
}
.redSearch {
  .search-text {
    border-color: #fb5f3b;
  }
  .search-btn {
    background-color: #fb5f3b;
  }
}
.redSearch.animateSearch {
  .search-text {
    border-color: #fb5f3b;
    width: 361px;
  }
  .search-btn {
    background-color: #fb5f3b;
  }
}
.ebSearch.animateSearch {
  width: 100%;
  .search-del {
    right: 42px;
  }
}
.search-long{
   width: 400px;
   .search-text {
    width: 361px;
  }
}
</style>
